<!-- Job management -->
<div class="main-ag-grid-container flex-column">
    <mat-card class="h-100">
        <!-- Toolbar -->
        <div class="grid-toolbar">
            <!-- Grid Header -->
            <div class="grid-title">
                <h3>Job Management</h3>
            </div>
            <div class="grid-tool-panel-btn-container">
                <!-- Rows Selected User Feedback -->
                <caption *ngIf="selectedJobs.length > 0">
                    {{
                        selectedJobs.length
                    }}
                    Job{{
                        selectedJobs.length === 1 ? '' : 's'
                    }}
                    Selected
                </caption>
                <!-- Create Job -->
                <span>
                    <button
                        mat-raised-button
                        color="accent"
                        class="primary-split-button"
                        (click)="onEnterJobCreatorScreen(null, 'create')"
                    >
                        Create Job
                    </button>
                    <!-- More Options -->
                    <button
                        id="split-button"
                        mat-raised-button
                        color="accent"
                        [matMenuTriggerFor]="moreOptions"
                        #tooltip="matTooltip"
                        matTooltip="More Options"
                        matTooltipClass="below"
                    >
                        <mat-icon
                            aria-hidden="false"
                            aria-label="More Options"
                            class="m-0"
                            >menu_open</mat-icon
                        >
                    </button>
                </span>
                <!-- Run Jobs button -->
                <mat-menu #moreOptions="matMenu">
                    <button
                        class="menu-panel-accent-btn"
                        mat-menu-item
                        color="accent"
                        (click)="onRunJobs($event)"
                        [disabled]="
                            processingData ||
                            selectedJobs.length === 0 ||
                            !gridActionsEnabled.delete
                        "
                    >
                        Run Job(s)
                    </button>
                    <!-- Menu divider -->
                    <mat-divider> </mat-divider>
                    <!-- Delete Jobs confirm popup -->
                    <app-confirm-popup
                        #confirmPopup
                        (confirmModal)="onDeleteJobs($event)"
                    ></app-confirm-popup>
                    <!-- Delete Jobs button -->
                    <button
                        class="menu-panel-warn-btn"
                        color="accent"
                        mat-menu-item
                        color="warn"
                        (click)="confirmPopup.confirm($event, 'Delete Jobs')"
                        [disabled]="
                            processingData ||
                            selectedJobs.length === 0 ||
                            !gridActionsEnabled.run
                        "
                    >
                        Delete Job(s)
                    </button>
                </mat-menu>
            </div>
        </div>
        <!-- AG Grid -->
        <ag-grid-angular
            id="size-distro-execution-job-management-grid"
            class="ag-theme-alpine ag-grid-container"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)"
            [attr.tool-panel]="true"
        >
        </ag-grid-angular>
    </mat-card>
</div>
